export enum DatiqInputTypes {
    Text = "text",
    Number = "number",
    Integer = "integer",
    SimpleInteger = "simpleInteger",
    Currency = "currency",
    SimpleCurrency = "simpleCurrency",
    Percent = "percent",
    SimplePercent = "simplePercent",
    Date = "Date",
    DateRange = "DateRange",
    Checkbox = "Checkbox",
    Switch = "Switch",
    Select = "Select",
    Checklist = "checklist",
    Slider = "slider",
    SliderRange = "sliderRange",
    Timeline = "timeline",
    ToggleButton = "toggleButton",
    Geo = "geo",
    Toggle = "Toggle",
}

export enum DatiqInputErrorTypes {
    Required = "required",
    MinLength = "minlength",
    MaxLength = "maxlength",
    Min = "min",
    Max = "max",
    Pattern = "pattern",
    PercentMin = "percentmin",
    PercentMax = "percentmax",
    DateMin = "datemin",
    DateMax = "datemax",
    DateRange = "daterange",
    DateInvalid = "matDatepickerParse",
    DateMinDays = "dateMinDays",
    DateMaxDays = "dateMaxDays",
    GeoIndeterminate = "geoIndeterminate",
    GeoPartial = "geoPartial",
    SelectMatchesOptions = "selectMatchesOptions",
}
